import type { IconName } from '@raiadrogasil/pulso-icons'
import { Button, type IButtonProps } from '~/components/button'
import type { TButtonSizes } from '~/components/button/types'
import type { TInputCounterProps } from '../types'

interface InputCounterButtonProps
  extends Omit<IButtonProps, 'variant' | 'size' | 'children'> {
  symbol?: IconName
  size?: TInputCounterProps['size']
  readonly?: boolean
}

const InputCounterButton = ({
  symbol,
  size,
  readonly,
  ...rest
}: InputCounterButtonProps) => {
  const mapSizeToButtonSize = (size: TInputCounterProps['size']) => {
    const sizeMap: Record<TButtonSizes, 'md' | 'ml' | 'lg' | 'xl'> = {
      md: 'md',
      ml: 'md',
      lg: 'ml',
      xl: 'ml',
    }

    return sizeMap[size]
  }

  return (
    <Button.Root
      {...rest}
      variant="neutral-tertiary"
      size={mapSizeToButtonSize(size || 'md')}
      disabled={rest.disabled || readonly}
    >
      <Button.Icon symbol={symbol} />
    </Button.Root>
  )
}

export const InputCounterMinusButton = (
  props: Omit<IButtonProps, 'variant' | 'size' | 'children'> & {
    symbol?: IconName
  }
) => {
  return (
    <InputCounterButton {...props} symbol={props.symbol || 'rdicon-minus'} />
  )
}
export const InputCounterPlusButton = (
  props: Omit<IButtonProps, 'variant' | 'size' | 'children'> & {
    symbol?: IconName
  }
) => {
  return (
    <InputCounterButton {...props} symbol={props.symbol || 'rdicon-plus'} />
  )
}
